import {FC} from 'react'
import {useLocation} from 'react-router-dom'
import queryString from 'query-string'
import {useSelector} from 'hooks/redux'
import {isAdminSelector, isOfficeAdminSelector} from 'libs/redux'
import {Errors} from './parts/Errors'
import {Setups} from './parts/Setups'
import {Plan} from './parts/Plan'
import {SystemAnnounces} from './parts/SystemAnnounces'
import {Notifications} from './parts/Notifications'
import {Alerts} from './parts/Alerts'
import {Procedures} from './parts/Procedures'
import {Tutorial} from './parts/Tutorial'
import {ProcedureStatusSummary} from './parts/ProcedureStatusSummary'
import {MyProcedureStatuses} from './parts/MyProcedureStatuses'
import {Profile} from './parts/Profile'
import styles from './Dashboard.scss'

// @ts-ignore
import SurveyModal from 'SurveyModal'

export const Dashboard: FC = () => {
  const {search} = useLocation()
  const employee = useSelector((state) => state.session.currentUser.employee)
  const isAdmin = useSelector((state) => isAdminSelector(state))
  const isOfficeAdmin = useSelector((state) => isOfficeAdminSelector(state))

  return (
    <div className={styles.dashboard}>
      {isAdmin && <Plan />}
      {isAdmin && <SurveyModal />}
      {queryString.parse(search)['error'] && <Errors />}
      {isAdmin && !isOfficeAdmin && <Setups />}

      <div className={styles.grid}>
        {isAdmin && <SystemAnnounces />}
        <Notifications isAdmin={isAdmin} />
        {!isAdmin && <MyProcedureStatuses />}
        {isAdmin && <Alerts />}
        {(isAdmin || (employee && employee.employment_status !== 'unemployed')) && <Procedures />}
        {isAdmin && <Tutorial />}
        {isAdmin && <ProcedureStatusSummary />}
        {employee && <Profile employee={employee} />}
      </div>
    </div>
  )
}
